// src/components/ErrorMessage.tsx
import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

interface ErrorDetails {
    message?: string;
    requestId?: string;
    cfId?: string;
    errorType?: string;
  }
  
  interface ErrorMessageProps {
    message: string;
    details?: string | ErrorDetails;
  }
  
  export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, details }) => {
    const [showDetails, setShowDetails] = useState(false);
    const [showIds, setShowIds] = useState(false);
  
    const handleToggleDetails = (event: React.MouseEvent) => {
      event.stopPropagation();
      setShowDetails(!showDetails);
    };
  
    const handleToggleIds = (event: React.MouseEvent) => {
      event.stopPropagation();
      setShowIds(!showIds);
    };
  
    const errorDetails = typeof details === 'string' ? { message: details } : details;
    const hasIds = errorDetails?.requestId || errorDetails?.cfId || errorDetails?.errorType;
  
    return (
      <Box onClick={(e) => e.stopPropagation()}>
        <Typography sx={{ color: 'white', mb: details ? 1 : 0 }}>
          {message}
        </Typography>
        {details && (
          <>
            <Button
              onClick={handleToggleDetails}
              startIcon={showDetails ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                textTransform: 'none',
                padding: 0,
                minWidth: 'auto',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: 'white'
                }
              }}
            >
              {showDetails ? 'Hide details' : 'Show details'}
            </Button>
            {showDetails && (
              <Box sx={{ mt: 1 }}>
                <Typography 
                  sx={{ 
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: '0.875rem',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word'
                  }}
                >
                  {errorDetails?.message}
                </Typography>
                
                {hasIds && (
                  <Box sx={{ mt: 1 }}>
                    <Button
                      onClick={handleToggleIds}
                      startIcon={showIds ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      sx={{
                        color: 'rgba(255, 255, 255, 0.5)',
                        textTransform: 'none',
                        padding: 0,
                        minWidth: 'auto',
                        fontSize: '0.75rem',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          color: 'rgba(255, 255, 255, 0.7)'
                        }
                      }}
                    >
                      {showIds ? 'Hide request IDs' : 'Show request IDs'}
                    </Button>
                    {showIds && (
                      <Box sx={{ mt: 0.5, pl: 2 }}>
                        {errorDetails?.requestId && (
                          <Typography sx={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.75rem' }}>
                            Request ID: {errorDetails.requestId}
                          </Typography>
                        )}
                        {errorDetails?.cfId && (
                          <Typography sx={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.75rem' }}>
                            CloudFront ID: {errorDetails.cfId}
                          </Typography>
                        )}
                        {errorDetails?.errorType && (
                          <Typography sx={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.75rem' }}>
                            Error Type: {errorDetails.errorType}
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            )}
          </>
        )}
      </Box>
    );
  };
  